import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Card, CardBody, UncontrolledCollapse } from 'reactstrap';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Menu from '../../components/Menu';
import BurgerMenu from '../../components/BurgerMenu';
import { ReactComponent as IconProfile } from '../../images/icn_attività.svg';
import { DataTable, Field, DateTimeField } from '../../components/DataTable';
import { ActivityTypeField, PriorityTypeField } from '../../components/DataTableFields';
import ActivityModal from '../../components/ActivityButtonGroup/ActivityModal';
import ActivityTypeSelectionModal from '../../components/ActivityButtonGroup/ActivityTypeSelectionModal';
import Filters from '../../components/Filters';
import { FILTERS } from '../../constants/filters';
import { useAuth } from '../../components/Auth';
import { isAdminRole } from '../../constants/user';
import plusIcon from '../../images/icn-plus.svg';

const Contact = ({ data }) => {
  const { contact_last_name = '', contact_first_name = '' } = data || {}
  return (
    <div>{contact_first_name} {contact_last_name}</div>
  )
}

function ActiivitiesPresentational({ activities, total, query = {}, onFilter, isLoading, onSaveActivity, isAdding = false, onDeleteActivity, onSort, sortField, sortOrder }) {
  const [t] = useTranslation('ACTIVITIES');
  const [{ profile = {} } = {}] = useAuth();
  const isAdmin = isAdminRole(profile?.role);
  const { offset } = query
  const [open, setOpen] = useState(false);
  const [activity, setActivity] = useState();
  const [openTypeSelection, setOpenTypeSelection] = useState(false);
  const [selectedType, setSelectedType] = useState(null);
  const [openNewActivity, setOpenNewActivity] = useState(false);

  const toggleModal = (activity = {}) => {
    if (open) {
      setOpen(!open)
      setActivity({})
    } else {
      setOpen(true)
      setActivity(activity)
    }
  }

  const toggleTypeSelection = () => {
    setOpenTypeSelection(!openTypeSelection);
  }

  const handleTypeSelection = (type) => {
    setSelectedType(type);
    setOpenNewActivity(true);
  }

  const toggleNewActivity = () => {
    setOpenNewActivity(!openNewActivity);
    if (!openNewActivity) {
      setSelectedType(null);
    }
  }

  const handleAddActivity = () => {
    toggleTypeSelection();
  }

  return (
    <div className="App">
      <Menu />

      <div className="corpo">
        <section>
          <Header
            title={t('COMMON:ACTIVITIES')}
            icon={<IconProfile fill='#FF6B38' />}
          />

          <div className="row">
            <div className="col-6">
              <Button className="btn-collapse" id="toggler" style={{ marginBottom: '1rem' }}>
                {t('COMMON:FILTER_BY')} <i className="fas fa-filter"></i>
              </Button>
            </div>
            <div className="col-6 text-right">
              <Button className="btn-plus" onClick={handleAddActivity} style={{ marginBottom: '1rem' }}>
                <img src={plusIcon} alt="" />
                {t('COMMON:ADD_ACTIVITY')}
              </Button>
            </div>
          </div>

          <UncontrolledCollapse toggler="#toggler">
            <div className="m-t-20">
              <Filters
                query={query}
                onFilter={onFilter}
                list={[FILTERS.CONTACT_ID, FILTERS.COMPANY_ID, ...(isAdmin ? [FILTERS.USER_ID] : []), FILTERS.ACTIVITY_TYPE, FILTERS.ACTIVITY_DONE]}
              />
            </div>
          </UncontrolledCollapse>

          <hr />

          <Card>
            <CardBody>
              <DataTable
                offset={offset}
                total={total}
                data={activities}
                isLoading={isLoading}
                loadingText={t('COMMON:LOADING')}
                emptyText={t('COMMON:NO_DATA')}
                onFilter={onFilter}
                onRowClick={toggleModal}
                onSort={onSort}
                sortField={sortField}
                sortOrder={sortOrder}
              >
                <Field title={t('COMMON:DESCRIPTION')} source="description" maxLength={40} />
                <ActivityTypeField title={t('TYPE')} source="type" />
                <Field title={t('COMMON:USER')} source="user_name" />
                <Contact title={t('CONTACT')} />
                <Field title={t('COMPANY')} source="company_name" />
                <Field title={t('DEAL')} source="deal_name" />
                <PriorityTypeField title={t('COMMON:PRIORITY')} source="priority" sortable={true} />
                <DateTimeField title={t('DATE')} source="date" sortable={true} />
                <Field title={t('DONE')} source='done' />
              </DataTable>
            </CardBody>
          </Card>

          {
            open && activity &&
            <ActivityModal
              activity={activity}
              open={open}
              toggle={toggleModal}
              onSubmit={(values) => {
                onSaveActivity({ values, type: activity.type, id: activity.id })
                toggleModal();
              }}
              onDeleteActivity={() => {
                onDeleteActivity(activity.id)
                toggleModal();
              }}
              type={activity && activity.type}
            />
          }

          <ActivityTypeSelectionModal
            open={openTypeSelection}
            toggle={toggleTypeSelection}
            onSelectType={handleTypeSelection}
          />

          {
            openNewActivity && selectedType &&
            <ActivityModal
              open={openNewActivity}
              toggle={toggleNewActivity}
              type={selectedType}
              user={profile.id}
              onSubmit={(values) => {
                onSaveActivity({ values, type: selectedType })
                toggleNewActivity();
              }}
              showDealSelect={true}
              showContactSelect={true}
            />
          }
        </section>
        <Footer />
      </div>
      <BurgerMenu />
    </div>
  );
}

export default ActiivitiesPresentational;
